import React from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import NewDocumentPopup from "./NewDocumentPopup";

/**
 * NewDocumentAction: () => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Button component in the context bar, which allows the user
 * to open the new document sheet and create a new document.
 *
 * @param {*} props
 */
const NewDocumentAction = props => (
  <NewDocumentPopup
    trigger={<Button color="blue">Erstellen</Button>}
    createDocument={props.createDocument}
    createContext={props.createContext}
    onOpen={props.onOpenNewSheet}
    onClose={props.onCloseNewSheet}
    isOpen={props.isSheetOpen}
    canCreateDocuments={props.canCreateDocuments}
  />
);

NewDocumentAction.propTypes = {
  /**
   * createDocument: () => ()
   * Action that is dispatched when a new document should be created
   */
  createDocument: PropTypes.func.isRequired,
  /**
   * createContext: () => ()
   * Action that is dispatched when a new context should be created
   */
  createContext: PropTypes.func.isRequired,

  /**
   * onOpenNewSheet / onCloseNewSheet: () => ()
   * Handlers that are fired when the popup is opened or closed through
   * the rendered action button (used to propagate state)
   */
  onOpenNewSheet: PropTypes.func.isRequired,
  onCloseNewSheet: PropTypes.func.isRequired,

  /**
   * isSheetOpen: Boolean
   * True if the new document popup is visible
   */
  isSheetOpen: PropTypes.bool.isRequired,

  /**
   * canCreateDocuments: Boolean
   * True if the user should be able to create documents
   */
  canCreateDocuments: PropTypes.bool.isRequired
};

export default NewDocumentAction;



// WEBPACK FOOTER //
// ./src/components/contextbar/NewDocumentAction.js